import { Link } from "react-router-dom";

import type { TournamentDivision } from "../lib/api";

/**
 * Candado por categoría: en torneos multi-categoría, cada división debe tener
 * su formato guardado antes de operar Ranking/Grupos/Draw. El guard global
 * del wizard solo protege borradores — en cuanto UNA categoría genera
 * partidos, el torneo "tiene datos" y las demás quedaban sin protección
 * (reporte Mex Tour Cup: avanzó la A y B/C entraron a Draw sin formato).
 */

export function divisionNeedsFormat(division: TournamentDivision | null | undefined): boolean {
  if (!division) return false;
  const config = division.format_config_json;
  return !config || Object.keys(config).length === 0;
}

export default function DivisionFormatGuardCard({
  tournamentId,
  division,
  stepLabel,
}: {
  tournamentId: number;
  division: TournamentDivision;
  stepLabel: string;
}) {
  return (
    <section className="card">
      <p className="card__eyebrow">Categoría sin formato</p>
      <h2 className="card__title">Falta guardar el formato de {division.name}</h2>
      <p className="card__subtitle">
        Cada categoría funciona como subtorneo. Sin su formato guardado, {stepLabel} no puede
        generar rondas ni brackets correctos para {division.name}. Guarda el formato y regresa.
      </p>
      <div className="form__actions">
        <Link className="btn" to={`/admin/tournaments/${tournamentId}/setup/format?division=${division.id}`}>
          Configurar formato de {division.name}
        </Link>
      </div>
    </section>
  );
}
